import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('TPA3DCarousel', () => {
      return Promise.all([
        import(
          './viewer/TPA3DCarousel' /* webpackChunkName: "TPA3DCarousel" */
        ),
        import(
          '../TPAGallery/viewer/TPAGallery.controller' /* webpackChunkName: "TPA3DCarousel" */
        ),
      ]).then(([componentModule, controllerModule]) => {
        return {
          component: componentModule.default,
          controller: controllerModule.default,
        };
      });
    });
  },
};

export default entry;
